import { render, staticRenderFns } from "./HomeProfile.vue?vue&type=template&id=190db83a&scoped=true&"
import script from "./HomeProfile.vue?vue&type=script&lang=js&"
export * from "./HomeProfile.vue?vue&type=script&lang=js&"
import style0 from "./HomeProfile.vue?vue&type=style&index=0&id=190db83a&lang=scss&scoped=true&"
import style1 from "./HomeProfile.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190db83a",
  null
  
)

export default component.exports